<template>
  <section class="">
    <Modal
      v-model:show="isEdit"
      class="modal-alert profile__modal-paymet-edit public-profile"
      @close="close"
    >
      <template v-slot:header>
        <h5 class="modal-title">
          {{ $t('profile.public_profile.edit.title') }}
        </h5>
      </template>

      <div class="form-group mb-0 mt-10">
        <UiInput
          v-model="form.name"
          v-model:error="errors_.name"
          :label="$t('profile.public_profile.name')"
          :placeholder="$t('profile.public_profile.name')"
          error-clear-on-change
        />
      </div>
      <template v-if="form.contacts.length">
        <div class="tw-grid tw-grid-cols-12 tw-gap-x-16 contacts mt-16 mb-4">
          <div class="column tw-col-span-6">
            <span class="form-title">{{ $t('profile.generalInfo.messenger') }}</span>
          </div>
          <div class="column tw-col-span-6">
            <span class="form-title messenger-id">{{ $t('profile.generalInfo.messengerId') }}</span>
          </div>
        </div>
        <div
          v-for="(item, i) in form.contacts"
          :key="i"
          class="item-container tw-grid tw-grid-cols-12 tw-gap-x-16 mb-12"
        >
          <div class="tw-col-span-6">
            <UiSelect
              v-model="item.type"
              :placeholder="$t('registration.placeholder_messenger')"
              :is-error="getContactError(i, 'type')"
              :list="messengers"
            />
          </div>
          <div class="tw-col-span-6 column">
            <ElTooltip
              placement="top"
              :disabled="!getContactError(i, 'value')"
              :content="getContactError(i, 'value')"
            >
              <UiInput
                v-model="item.value"
                :is-error="getContactError(i, 'value')"
                size="big"
                autosize
                type="text"
                class="input"
                :placeholder="$t('profile.generalInfo.messengerId')"
              />
            </ElTooltip>
            <i
              class="fas fa-trash-alt text-red ml-8 pointer"
              :class="{ disabled: form.contacts.length === 1 }"
              @click="deleteMessenger(i)"
            />
          </div>
        </div>
      </template>
      <span
        class="add-messenger"
        @click="addMessenger"
      >+ {{ $t('profile.public_profile.edit.add_another_messenger') }}</span>
      <div class="form-group select-wrapper mb-8">
        <UiTextarea
          v-model="form.additional_information"
          v-model:error="errors_.additional_information"
          :label="$t('profile.public_profile.edit.misc')"
          :placeholder="$t('profile.public_profile.edit.misc')"
          :rows="4"
        />
      </div>
      <template v-slot:footer>
        <div class="!tw-flex !tw-justify-end !tw-w-full mt-8 mr-0">
          <button
            class="btn btn-outline-primary btn-sm btn__back"
            @click="close"
          >
            {{ $t('profile.buttons.cancel') }}
          </button>
          <button
            class="btn btn-primary btn-sm ml-16"
            :disabled="isLoading"
            @click="save"
          >
            {{ $t('profile.buttons.save') }}
          </button>
        </div>
      </template>
    </Modal>
  </section>
</template>

<script>
import { Modal } from '@/components';

export default {
  components: {
    Modal,
  },
  data() {
    return {
      isEdit: false,
      form: this.defaultData(),

      isLoading: false,
      errors_: {},
      messengers: [
        {
          id: 'email',
          text: 'Email',
          example_placeholder: '@email',
        },
        {
          id: 'telegram',
          text: 'Telegram',
          example_placeholder: '@telegram',
        },
        {
          id: 'ms_teams',
          text: 'MS Teams',
        },
      ],
    };
  },
  computed: {},
  watch: {},

  methods: {
    getContactError(i, type) {
      return this.$_.get(this.errors_.contacts, [i, type, 0, 'message'], null);
    },
    defaultData() {
      return {
        name: '',
        contacts: [
          {
            type: null,
            value: '',
          },
        ],
        additional_information: '',
      };
    },
    open(data) {
      this.errors_ = {};
      this.isEdit = true;
      this.loading = true;

      this.form = this.$_.cloneDeep(data || this.defaultData());
    },
    deleteMessenger(i) {
      if(this.form.contacts.length <= 1) return;

      this.form.contacts = [...this.form.contacts.slice(0, i), ...this.form.contacts.slice(i + 1)];
    },
    addMessenger() {
      this.form.contacts.push({
        type: null,
        value: '',
      });
    },

    close() {
      this.isEdit = false;
    },

    save() {
      this.errors_ = {};

      this.isLoading = true;

      this.$api.putPublicProfile(this.form)
        .then(() => {
          this.$alert.success(this.$t('profile.public_profile.success.updated'));
          this.$store.dispatch('getProfileData');
          this.isEdit = false;
        })
        .catch((err) => {
          this.errors_ = err.response.data.errors;
        })
        .finally(() => this.isLoading = false);
    },
  },
};
</script>

<style lang="scss" scoped>
.item-container {
  // display: flex;
  // flex-wrap: wrap;
  align-items: center;

  // /deep/ {
  // vue3-migration -- удаляем /deep/
    :deep(.form-group input.form-control) {
      margin-top: 0;
    }
  // }
}
.ui-input {
  margin-bottom: 0;
}
.form-error-input {
  // /deep/ {
  // vue3-migration -- удаляем /deep/
    :deep(.input-wrapper input.input-element),
    :deep(.selection .select2-selection) {
      border-color: var(--color-text-red)!important;
    }
  // }
}

.form-error {
  font-size: 12px;
  text-align: right;
}

.contacts {
  display: flex;
  align-items: center;
  margin-bottom: 12px;

  // &.contacts {
  //   gap: 16px;
  // }

  // /deep/ {
  // vue3-migration -- удаляем /deep/
    :deep(.form-group input.form-control) {
      margin-top: 0;
    }
  // }
}

.form-title {
  font-size: 13px;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
}

.column {
  display: flex;
  align-items: center;
  flex: 1;

  .pointer {
    cursor: pointer;
  }

  .disabled {
    opacity: .5;
    cursor: not-allowed;
  }
}

.add-messenger {
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text-green);
}

.public-profile {
  @media (max-width:544px) {
    max-width: 100%;

    // /deep/ {
    // vue3-migration -- удаляем /deep/
      :deep(.ui-input.el-tooltip.input) {
        width: calc(100% - 22px)!important;
      }
    // }
  }
}
</style>
